export const NICHES = ["Café / Restaurant", "Bakery & Desserts", "Salon & Beauty", "Fitness / Gym", "Doctor / Clinic",
  "Interior Design", "Fashion / Boutique", "D2C Product", "Coach / Consultant", "Real Estate"];
export const PLATFORMS = ["Instagram", "Facebook", "LinkedIn", "YouTube Shorts"];
export const GOALS = ["Get more customers", "Grow followers", "Build brand trust", "Launch something new"];

export const LEVELS = [
  { key: "you", title: "First, who's playing?", sub: "So we can personalise your calendar.", emoji: "Level 1" },
  { key: "biz", title: "What's your business?", sub: "Pick your niche or type your own.", emoji: "Level 2" },
  { key: "rival", title: "Who's your competitor?", sub: "A brand you compete with or look up to.", emoji: "Level 3" },
  { key: "goal", title: "Pick your playground", sub: "Where you post and what you want.", emoji: "Final level" },
];
